import { Component, OnInit } from '@angular/core';
import { PayrollFilter } from '../../../models/salaries/payroll.filter';
import { PageOption } from '../../../models/common/pageOption';
import { Payroll } from '../../../models/salaries/payroll';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { TableColumn } from '../../../models/tables/TableColumn';
import { PayrollColumns } from '../../../contants/columns/columns.payroll.list';
import { PayrollService } from '../../../services/payroll.service';
import { ParameterService } from '../../../services/parameter.service';
import { CommonService } from '../../../services/common.service';
import { PARAMS } from '../../../contants/PARAMS';
import { DateHelper } from '../../../helpers/DateHelper';
import * as moment from 'moment';

@Component({
	selector: 'app-payroll-list',
	templateUrl: './payroll-list.component.html',
	styleUrls: ['./payroll-list.component.css']
})
export class PayrollListComponent implements OnInit {
	pageOption: PageOption<PayrollFilter> = new PageOption();
	formPath: string = APP_ROUTES.payrollForm;
    dateFrom: string;
    dateTo: string;

	public payrolls: Payroll[] = [];
	public tableColumns: TableColumn[] = PayrollColumns;

	constructor(
		private _payrollService: PayrollService,
		private _parameterService: ParameterService,
		private _commonService: CommonService
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new PayrollFilter();
		
		this.pageOption.searchFilter.from = DateHelper.getDateString(moment().startOf('month').subtract(1, 'month').toDate());
		this.pageOption.searchFilter.to = DateHelper.getDateString(moment().endOf('month').toDate());

		this._parameterService.getCachedParameterObject<TableColumn[]>(PARAMS.TRIP_TABLE_DEFAULT_COLUMNS, 3600).subscribe(
			result => {
				if (result != undefined && result.length != undefined) {
					this.tableColumns = result.length == 0 ? this.tableColumns : result;
				}
				else {
					console.log('Invalid response from server, will use default column settings instead.')
				}
			});

		this._parameterService.getCachedParameter<number>(PARAMS.TRIP_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
			value => {
				value = Number(value);
				this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
				this.pageOption.pageNumber = 1;

				this.fetchData();
			}
		);
	}

	fetchData(){
		this._payrollService.getPayrollsList(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let startIndex = ((result.pageNumber - 1) * this.pageOption.pageSize);
					this._commonService.insertAt(this.payrolls, startIndex, result.data);
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	toggleFilter() {
		this.payrolls = []; //reset array
		this.pageOption.searchFilter.from = this.dateFrom;
		this.pageOption.searchFilter.to = this.dateTo;
		this.fetchData();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/salaries/payroll-list/payroll-list.component.ts